import React from 'react';

const Service = () => {
    return (
        <div>
          <section id="service">
        <div className="container">
          <div className="row">
            <div className="service-main">
              <div className="col-md-4">
                <div className="service-item text-center">
                  <h3><i className="fa fa-truck rotat" /> Free Shipping</h3>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                </div>
              </div>
              <div className="col-md-4 service-mid">
                <div className="service-item text-center">
                  <h3><i className="fa fa-support" /> 24/7 Support</h3>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="service-item text-center">
                  <h3><i className="fa fa-money" /> Cashback</h3>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        </div>
    );
};

export default Service;